import { PiniaColada } from "@pinia/colada";
import { createPinia } from "pinia";
import { createApp } from "vue";

import { initPrimeVue } from "@solvari/components";
import { getSentry } from "@solvari/utils";

import { getRootElement } from "@/helpers/rootElement";

import App from "./App.vue";

function main() {
  const app = createApp(App);
  getSentry().trackVueErrors(app);

  app.use(createPinia());
  app.use(PiniaColada, {});
  initPrimeVue(app);

  app.mount(getRootElement());
}

main();
